export default class Autosuggest {
  props = {
    keys: {
      ESC: 27,
      TAB: 9,
      RETURN: 13,
      SPACE: 32,
      LEFT: 37,
      UP: 38,
      RIGHT: 39,
      DOWN: 40
    },
    resultsList: [],
    cache: {}
  };

  constructor(selectorInput, selectorOptionsList) {
    this.selectorInput = selectorInput;
    this.selectorOptionsList = selectorOptionsList;
  }

  hide = () => {
    $(this.selectorOptionsList)
      .empty()
      .hide();
  };

  showList = () => {
    $(this.selectorOptionsList).show();
  };

  clear = () => {
    this.props.resultsList = [];
    $(this.selectorInput)
      .val("")
      .parent()
      .addClass("is-empty");

    $(this.selectorInput)
      .parents(".form")
      .removeClass("is-active");

    this.hide();
  };

  handleSearchUpdate = () => {
    const searchField = $(this.selectorInput);

    // TODO: classes that use in js must have js- prefix in classname
    $(".search__combobox .search__options-list-item")
      .off()
      .on("click", event => {
        searchField.val($(event.target).text());
        this.hide();
        return false;
      })
      .on("keydown", event => {
        if (event.keyCode === this.props.keys.SPACE) {
          searchField.val($(event.target).text());
          this.hide();
          return false;
        }

        if (event.keyCode === this.props.keys.ESC) {
          this.hide();
          return false;
        }
      });
  };

  // TODO: rewrite to more modular (class hardcoded)
  handleClose = () => {
    $(document).on("click", event => {
      if (!$(event.target).closest("search__combobox").length) {
        this.hide();
      }
    });
  };

  getCache = () => {
    const storageCache = localStorage && localStorage.getItem("cache");
    const cache = storageCache && JSON.parse(storageCache);

    this.props.cache = cache || this.props.cache;
  };

  updateStorage = () => {
    try {
      if (localStorage) {
        localStorage.setItem("cache", JSON.stringify(this.props.cache));
      }
    } catch (e) {
      console.log(`can't update localStorage.`, e);
    }
  };

  render = resultsList => {
    const emptyResult = "Sorry, we did not find any results.";
    const listElement = $(this.selectorOptionsList);
    const listItems =
      resultsList &&
      Array.isArray(resultsList) &&
      resultsList.length &&
      resultsList.map(
        item =>
          `<li class="search__options-list-item" role="option" tabindex="0">${item}</li>`
      );

    listElement.empty();

    if (resultsList.length) {
      listElement.append(listItems);
      this.showList();
      this.handleSearchUpdate();
    } else {
      // listElement.append(
      //   `<li class="search__options-list-item search__options-list-item--empty-result" role="option">${emptyResult}</li>`
      // );
      // this.showList();
      this.hide();
    }
  };

  search = query => {
    // If query match with cache don`t do ajax
    if (Object.keys(this.props.cache).find(item => item === query)) {
      this.props.resultsList = this.props.cache[query];
      this.render(this.props.resultsList);
      return false;
    }

    // TODO: error handling
    if (query.length >= 2) {
      $(this.selectorInput)
        .parent()
        .removeClass("is-empty");

      $.ajax({
        url: "/autosuggest",
        data: { q: query },
        success: data => {
          this.props.cache[query] = data;
          this.updateStorage();
          this.render(data);
        },
        error: response => {
          console.log(response);
          this.render([]);
        }
      });
    }
  };

  handleClear = () => {
    $(".search__select-state-clear").on("click", () => {
      this.clear();
    });
  };

  handleInput = () => {
    let timer = null;
    const searchField = $(this.selectorInput);

    searchField.off().on("keyup", () => {
      if (timer) {
        window.clearTimeout(timer);
      }

      timer = window.setTimeout(() => {
        timer = null;
        if (searchField.val() === "") {
          this.clear();
        }

        this.search(searchField.val());
        $(".form").addClass("is-active");
      }, 500);
    });
  };

  init = () => {
    this.hide();
    this.getCache();
    this.handleInput();
    this.handleClose();
    this.handleClear();
  };
}
